const NestPassInVoiceTemplate = ({ invoice }) => {
  return `<!DOCTYPE html>
<html>
<head>
<style>
  table, th, td {
    border: 1px solid black;
    border-collapse: collapse;
  }
</style>
</head>
<body>

<h2>INVOICE: Nest Pass</h2>
<p style="font-weight: bold">NATIVE ROOTS RETAIL PRIVATE LIMITED<br/>
No.53, Kaveri Layout, Hebbal, Kempapura<br/>
Bangalore North, Bangalore - 560024, Karnataka</p>

<table width="950">
  <tr>
    <td colspan="7" style="font-weight: bold">Details of Receiver</td>
    <td colspan="2" style="font-weight: bold">Date</td>
    <td colspan="5">${invoice.invoiceDate}</td>
  </tr>
  <tr>
    <td colspan="2" style="font-weight: bold">Name</td>
    <td colspan="5">${invoice.customerName}</td>
    <td colspan="2" style="font-weight: bold">EInvoice #</td>
    <td colspan="5">${invoice._id}</td>
  </tr>
  <tr>
    <td colspan="2" style="font-weight: bold"></td>
    <td colspan="5"></td>
    <td colspan="7">Phone: ${invoice.customerPhone}</td>
  </tr>

  <tr><td colspan="14"><br/></td></tr>

  <tr>
    <td rowspan="2" style="font-weight: bold">SL NO</td>
    <td rowspan="2" style="font-weight: bold">Description of Goods</td>
    <td rowspan="2" style="font-weight: bold">HSN Code</td>
    <td rowspan="2" style="font-weight: bold">Ord Qty</td>
    <td rowspan="2" style="font-weight: bold">Rate</td>
    <td rowspan="2" style="font-weight: bold">Total</td>
    <td rowspan="2" style="font-weight: bold">Discount</td>
    <td rowspan="2" style="font-weight: bold">Total</td>
    <td colspan="2" style="font-weight: bold">CGST</td>
    <td colspan="2" style="font-weight: bold">SGST</td>
  </tr>
  <tr>
    <td style="font-weight: bold">Rate</td>
    <td style="font-weight: bold">Amount</td>
    <td style="font-weight: bold">Rate</td>
    <td style="font-weight: bold">Amount</td>
  </tr>

  <tr>
    <td>1</td>
    <td>${invoice.description}</td>
    <td>${invoice.hsn}</td>
    <td>${invoice.quantity}</td>
    <td>${invoice.rate}</td>
    <td>${invoice.totalWithRateQty}</td>
    <td>${invoice.discount}</td>
    <td>${invoice.totalAfterDiscount}</td>
    <td>${invoice.CGST.rate}</td>
    <td>${invoice.CGST.amount}</td>
    <td>${invoice.SGST.rate}</td>
    <td>${invoice.SGST.amount}</td>
  </tr>

  <tr>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td>${invoice.totalAfterDiscount}</td>
    <td></td>
    <td>${invoice.CGST.amount}</td>
    <td></td>
    <td>${invoice.SGST.amount}</td>
  </tr>

  <tr>
    <td colspan="8" style="text-align: right">Total Payable</td>
    <td></td>
    <td></td>
    <td></td>
    <td>${invoice.totalPayable}</td>
  </tr>
</table>

</body>
</html>`;
};

export default NestPassInVoiceTemplate;